import { render } from "./about.vue?vue&type=template&id=a3245132&scoped=true"
const script = {}

import "./about.vue?vue&type=style&index=0&id=a3245132&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a3245132"]])

export default __exports__